export default __webpack_public_path__ + "static/media/logoTuna.29da7a39.png";